export default class Parrot {
  constructor() {
    this.API_URL = process.env.REACT_APP_API_URL;
  }

  getRssUrl = async (token) => {
    return fetch(this.API_URL + '/rss_link/', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer'
    }).then(response => {
      if (!response.ok) {
        console.log('response was not a 200-299 status code');
      }
      return response.json();
    }).catch(err => {
      console.log('Error', err);
    });
  }

  getUserInfo = async (token) => {
    return fetch(this.API_URL + '/get_user_info/', {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer'
    }).then(response => {
      if (!response.ok) {
        console.log('response was not a 200-299 status code');
      }
      return response.json();
    }).catch(err => {
      console.log('Error', err);
    });
  }

  getContent = async (getContentObj) => {
    return fetch(this.API_URL + '/get_content/', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(getContentObj)
    }).then(response => {
      if (!response.ok) {
        console.log('response was not a 200-299 status code');
      }
      return response.json();
    }).catch(err => {
      console.log('Error', err);
    });
  }

  userHasRequested = async (token, contentId) => {
    return fetch(this.API_URL + '/user_has_requested/', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify({content_id: contentId})
    }).then(response => {
      if (!response.ok) {
        console.log('response was not a 200-299 status code');
      }
      return response.json();
    }).catch(err => {
      console.log('Error', err);
    });
  }

  claimRequestedRecording = async (token, id) => {
    return fetch(this.API_URL + '/claim_narration/', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify({"content_id": id})
    }).then(response => {
      if (!response.ok) {
        console.log('response was not a 200-299 status code');
      }
      return response.json();
    }).catch(err => {
      console.log('Error', err);
    });
  }

  postRecording = async (token, id, file) => {
    var formData = new FormData();
    formData.append('file', file);
    return fetch(this.API_URL + `/upload/${id}/`, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: formData
    }).then(response => {
      if (!response.ok) {
        console.log('response was not a 200-299 status code');
      }
      return response.json();
    }).catch(err => {
      console.log('Error', err);
    });
  }

  getArticleInfo = async (token, getArticleInfoObj) => {
    return fetch(this.API_URL + '/get_article_info/', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(getArticleInfoObj)
    }).then(response => {
      if (!response.ok) {
        console.log('response was not a 200-299 status code');
      }
      return response.json();
    }).catch(err => {
      console.log('Error', err);
    });
  }

  confirmRequestNarration = async (token, confirmRequestNarrationObj) => {
    return fetch(this.API_URL + '/request_narration/', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(confirmRequestNarrationObj)
    }).then(response => {
      if (!response.ok) {
        console.log('response was not a 200-299 status code');
      }
      return response.json();
    }).catch(err => {
      console.log('Error', err);
    });
  }

  getDashboardData = async (token) => {
    return fetch(this.API_URL + '/dashboard_data/', {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer'
    }).then(response => {
      if (!response.ok) {
        console.log('response was not a 200-299 status code');
      }
      return response.json();
    }).catch(err => {
      console.log('Error', err);
    });
  }

  getOpenRequestedRecordings = async (token) => {
    return fetch(this.API_URL + '/get_open_requests/', {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer'
    }).then(response => {
      if (!response.ok) {
        console.log('response was not a 200-299 status code');
      }
      return response.json();
    }).catch(err => {
      console.log('Error', err);
    });
  }
}
